import Dialog from "@components/dialog";
import { IFormTableListSection } from "@pages/payroll/payslip/formTableList/FormTableList";
import { EditDialogWrapper, SectionTitle } from "@pages/payroll/payslip/formTableList/FormTableList.styles";
import FormTableListEditDialogRow from "@pages/payroll/payslip/formTableList/FormTableListEditDialogRow";
import i18next from "i18next";
import React, { useCallback } from "react";

import { RefRegistrar } from "../../../../model/RefRegistrar";
import { FormStorage } from "../../../../views/formView/FormStorage";
import ConfirmationButtons from "../../../../views/table/ConfirmationButtons";

interface IProps {
    storage: FormStorage;
    title: string;
    sections: IFormTableListSection[];
    onSave: () => void;
    onCancel: () => void;
}

// component to render a table list in form view, possible sections, rows and sub-rows
// wrapper can have pink background
// local for now, we may move it to components in case it's reused somewhere else
const FormTableListEditDialog: React.FC<IProps> = ({ storage, sections, onSave, onCancel, title }) => {
    const { bindingContext } = storage.data;

    const handleCancel = useCallback(() => {
        onCancel?.();
    }, [onCancel]);

    if (!sections.length || sections.length <= 0) {
        return null;
    }

    const storageHasError = () => {
        // todo: in case there might be different temporal data than Items, check also key structure
        return !!Object.keys(storage.data.temporalData).find(key =>
            !!storage.data.temporalData[key].additionalFieldData?.error);
    };

    return (
            <RefRegistrar bindingContext={bindingContext} storage={storage}>
                {() => (
                        <Dialog title={title}
                                busy={storage.isBusy()}
                                onClose={handleCancel}
                                onConfirm={onSave}
                                footer={<ConfirmationButtons onConfirm={onSave}
                                                             onCancel={handleCancel}
                                                             isDisabled={storageHasError()}
                                                             confirmText={i18next.t("Common:General.Save")}
                                                             useWrapper={false}/>}>
                            <EditDialogWrapper>
                                {sections.map((section, index) => (<React.Fragment key={index}>
                                    <SectionTitle $columns={3}>
                                        {section.title}
                                    </SectionTitle>
                                    {section.rows.map((row) => (
                                            <FormTableListEditDialogRow key={row.editableInfo.Id} storage={storage} row={row}/>
                                    ))}
                                </React.Fragment>))}
                            </EditDialogWrapper>
                        </Dialog>
                )}
            </RefRegistrar>
    );
};

export default FormTableListEditDialog;